import React from "react";
import ReactDOM from "react-dom";

import "./css/index.css";
import FAQ from "./components/FAQ";

// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<FAQ />, document.getElementById("root"));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js